import "./VehiclesTools.scss";

import { useDispatch } from "react-redux";

import { openDrawer } from "../../../slices/drawerSlice";
import { openModal } from "../../../slices/modalSlice";

import FilterAlt from "@mui/icons-material/FilterAlt";
import FileDownload from "@mui/icons-material/FileDownload";

import { SearchBar } from "../../../common-components/SearchBar/SearchBar";
import { TextButton } from "../../../common-components/Buttons/Buttons";
import { IconButton } from "../../../common-components/Buttons/Buttons";

import VehiclesFiltersFooter from "../VehiclesFilters/components/VehiclesFiltersFooter/VehiclesFiltersFooter";
import VehiclesFiltersTools from "../VehiclesFilters/components/VehiclesFiltersTools/VehiclesFiltersTools";
import VehiclesFilters from "../VehiclesFilters/components/VehiclesFilters";
import VehiclesExportModal from "../../../components/vehicles-export-modal/VehiclesExportModal";

const VehiclesTools = () => {
    const dispatch = useDispatch();

    const handleOpenDrawer = () => {
        dispatch(openDrawer({content: <VehiclesFilters/>, tools: <VehiclesFiltersTools/>, footer: <VehiclesFiltersFooter/>}))
    }

    const handleOpenModal = () => {
        dispatch(openModal({content: <VehiclesExportModal/>, closeable: true}));
    }

    return (
        <div className={"vehicles-tools"}>
            <div className={"vehicles-tools_container"}>
                <div className={"vehicles-tools_search"}>
                    <SearchBar componentId={"vehicles"}/>
                </div>
                <div className={"vehicles-tools_desktop-buttons"}>
                    <TextButton Icon={FilterAlt} title={"Фильтр"} onClick={handleOpenDrawer} active={true}/>
                    <TextButton Icon={FileDownload} title={"Экспорт в Excel"} onClick={handleOpenModal} active={true}/>
                </div>
                <div className={"vehicles-tools_mobile-buttons"}>
                    <IconButton Icon={FilterAlt}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesTools;